import MentionsLegales from "../MentionLegales";
import "../../assets/style/mentions-legal.css";

export default function IndexPage() {
  return (
    <div className="index-page">
      <MentionsLegales
        siteUrl="https://maelcorp.com/"
        nomSociete="MaelCorp."
        capital="1 000 €"
        villeRcs="Nice"
        adresse="58 Corniche Fleurie – 06000 Nice France"
        siren="914 813 282"
        responsablePublication="Maël COLONNESE"
        hebergeurNom="OVH SAS"
        hebergeurCapital="10 000 000 €"
        hebergeurAdresse="2, Rue Kellermann – 59100 Roubaix France"
      />
    </div>
  );
}
